var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_24997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81859 11.3783C7.80859 11.4383 7.79859 11.4983 7.79859 11.5683C7.79859 11.6283 7.79859 11.6883 7.81859 11.7583C7.82859 11.8183 7.84859 11.8783 7.86859 11.9383C7.88859 11.9983 7.92859 12.0583 7.96859 12.1183C7.98859 12.1483 7.99859 12.1883 8.01859 12.2183C8.03859 12.2383 8.06859 12.2483 8.08859 12.2783C8.10859 12.2983 8.11859 12.3283 8.14859 12.3483L13.8986 17.1583C14.3186 17.5083 14.9486 17.4583 15.3086 17.0283C15.6586 16.6083 15.6086 15.9783 15.1786 15.6183L10.3386 11.5783L15.1786 7.53826C15.5986 7.18826 15.6586 6.54826 15.3086 6.12826C15.1086 5.88826 14.8286 5.76826 14.5386 5.76826C14.3086 5.76826 14.0886 5.84826 13.8986 5.99826L8.14859 10.8083C8.14859 10.8083 8.10859 10.8583 8.08859 10.8883C8.06859 10.9083 8.03859 10.9183 8.02859 10.9383C8.00859 10.9683 7.99859 11.0083 7.97859 11.0383C7.93859 11.0983 7.90859 11.1483 7.87859 11.2183C7.85859 11.2783 7.83859 11.3383 7.82859 11.3983L7.81859 11.3783Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_24997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.872bcfd1fdf8744ca2b4579c85a1237b.svg";
export { ForwardRef as ReactComponent };